import { Injectable } from '@angular/core';
import { CrudService } from '../../crud.service';
import { HttpClient, HttpParams} from '@angular/common/http';
import { CluesResponse } from 'src/app/core/models/configuration/branchoffice/clues.model';
import { urlServiceHospitalInfra } from 'src/app/core/constants/hospital-infra.constants';
import { CluesFilterDto } from 'src/app/core/models/configuration/branchoffice/clues-filter-dto';

@Injectable({
  providedIn: 'root'
})
export class CluesService extends CrudService {

  constructor(
    protected override http: HttpClient,
  ) {
    super(http);
  }

  public async getCluesAddress(clue: string): Promise <CluesResponse| null>{
    return await this.get<CluesResponse>(`${urlServiceHospitalInfra.clue.one}${clue}`, undefined, true)
  }

  public async getCluesAutocomplete(keyClue: string): Promise <string[]| null>{
    return await this.get<string[]>(`${urlServiceHospitalInfra.clue.autocomplete}${keyClue}`, undefined, true)
  }
  
  public async getCluesAutocompleteByFilter(filter: CluesFilterDto ): Promise <string[]| null>{
    let params = new HttpParams();
    if(!filter.releaseDateStr){
      return null;
    }
    if(filter.clue){
      params = params.append('clue', filter.clue);
    }
    params = params.append('releaseDate', filter.releaseDateStr);
    
    return await this.get<string[]>(`${urlServiceHospitalInfra.clue.filter}`, params, true)
  }

  public async getStates(): Promise<string[] | null> {
    return await this.get<string[]>(urlServiceHospitalInfra.clue.states, undefined, true);
  }
  public async getCluesByStates(state: string): Promise<CluesResponse[] | null> {
    return await this.get<CluesResponse[]>(`${urlServiceHospitalInfra.clue.bystate}${state}`, undefined, true);
  }
  public async getCluesDetails(clue: string): Promise <CluesResponse| null>{
    return await this.get<CluesResponse>(`${urlServiceHospitalInfra.clue.details}${clue}`, undefined, true)
  }


}
